import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import logo from '../../../image/home/swasthforclincian-logo@3x.png';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const userInfo = localStorage.getItem('isLoggedin') === 'true';
  return (
    <div className='home-header centered-content'>
      <div className='logo-container'>
        <a href='/'>
          <img alt='Swasth Clinicians' src={logo} className='swasth-clinicians-white' />
        </a>
      </div>
      <div className='menu-container fold-close'>
        <nav className='menu' role='navigation' aria-label='main-navigation'>
          <a href='https://resiliens.com/about-us' target='_blank' className='menu-item base-text'>
            About Us
          </a>
          {/* <Link to='/pricing' className='menu-item base-text'>
            Pricing
          </Link> */}
          <a href='https://help.swasth.co' target='_blank' className='menu-item base-text'>
            Help
          </a>
        </nav>
        {!userInfo ? (
          <div className={`header-auth-buttons `}>
            <Link to='/signin' className='login-btn base-text'>
              Login
            </Link>
            <Link to='/signup' className='login-btn signup-btn base-text'>
              Signup Now
            </Link>
          </div>
        ) : (
          <div className='header-auth-buttons'>
            <Link to='/app/clients' className='login-btn'>
              Dashboard
            </Link>
          </div>
        )}
      </div>
      <div className='folded-menu' hidden={!isOpen}>
        <nav className='menu' role='navigation' aria-label='main-navigation'>
          <a href='https://resiliens.com/about-us' target='_blank' className='menu-item base-text'>
            About Us
          </a>
          <Link to='/pricing' className='menu-item base-text'>
            Pricing
          </Link>
          <a href='https://help.swasth.co' target='_blank' className='menu-item base-text'>
            Help
          </a>
        </nav>
        {!userInfo ? (
          <div className={`header-auth-buttons `}>
            <Link to='/signin' className=' base-text'>
              Login
            </Link>
            <Link to='/signup' className='base-text'>
              Signup Now
            </Link>
          </div>
        ) : (
          <div className='header-auth-buttons'>
            <Link to='/app/clients'>Dashboard</Link>
          </div>
        )}
      </div>
      <a className='menu-fold-icon' href='javascript:void(0)' onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <Icon className='icon' type='close' /> : <Icon className='icon' type='menu' />}
      </a>
    </div>
  );
}

export default Header;
